import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]

import helpers from '@/helpers';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserAvatar',
  props: {
  avatarId: {
    type: [String, Number],
    default: '',
  },
  size: {
    type: [String, Number],
    default: '40',
  },
},
  setup(__props) {

const props = __props;

const userAvatarImgUrl = computed((): string | undefined => {
  if (props.avatarId) {
    return helpers.url.outerUrl(
      `/images/${props.avatarId}/${props.size}x${props.size}/Profile.png`,
    );
  } else {
    return helpers.url.outerUrl(`/images/0/${props.size}x${props.size}/Profile.png`);
  }
});

const avatarDefaultStyle = computed(() => {
  return {
    'border-radius': `${props.size}px`,
    height: `${props.size}px`,
    width: `${props.size}px`,
  };
});

return (_ctx: any,_cache: any) => {
  return (userAvatarImgUrl.value)
    ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 0 }, _ctx.$attrs, { class: "user-profile-menu__user-avatar" }), [
        _createElementVNode("img", {
          alt: "user avatar",
          style: _normalizeStyle(avatarDefaultStyle.value),
          src: userAvatarImgUrl.value
        }, null, 12, _hoisted_1)
      ], 16))
    : _createCommentVNode("", true)
}
}

})